export const enum CreditStatus {
  /**
   * no credit: 0
   */
  UNCREDITED = 0,
  /**
   * crediting: 1
   */
  CREDITING = 1,
  /**
   * rejected: 2
   */
  REJECTED = 2,
  /**
   * passed: 3
   */
  PASSED = 3,
  /**
   * lending: 4
   */
  LENDING = 4,
  /**
   * lend failed: 5
   */
  LEND_FAILED = 5,
  /**
   * lend failed with not allowed retry: 6
   */
  LEND_FAILED_WITH_NOT_ALLOWED_RETRY = 6,
  /**
   * repaying: 7
   */
  REPAYING = 7,
  /**
   * need complete info: 8
   */
  NEED_COMPLETE_INFO = 8,
  /**
   * need face recognition: 9
   */
  NEED_FACE_RECOGNITION = 9,
  /**
   * face recognition limit exceeded: 10
   */
  FACE_RECOGNITIONING_LIMIT_EXCEEDED = 10,
  /**
   * Appointment loan examining: 11
   */
  RESERVE_LOAN_AUDITING = 11,
  /**
   * Appointment loan lending: 12
   */
  RESERVE_LENDING = 12,
  /**
   * Cancelling withdrawal page under review: 13
   */
  CANCEL_LOAN_AUDITING = 13,
  /**
   * loaning rejected: 14
   */
  LOANING_REJECTED = 14,
  /**
   * no loan rejected: 15
   */
  NO_LOAN_REJECTED = 15,
}

export const enum BorrowStatus {
  /**
   * 0-cancel loan
   */
  CANCEL_LOAN = 0,
  /**
   * 1-lending
   */
  LENDING = 1,
  /**
   * 2-loan passed
   */
  LOAN_PASSED = 2,
  /**
   * 3-loan failed
   */
  LOAN_FAILED = 3,
  /**
   * 5-overdue
   */
  OVERDUE = 5,
  /**
   * 6-examining
   */
  EXAMINING = 6,
  /**
   * 7-need add record
   */
  NEED_ADD_RECORD = 7,
  /**
   * 8-review rejected loan
   */
  REVIEW_REJECTED_LOAN = 8,
  /**
   * 9-need face recognition
   */
  NEED_FACE_RECOGNITION = 9,
}
